<template>
  <div class="modal d-block show" tabindex="-1" role="dialog" v-if="show">
    <div
      class="modal-dialog"
      role="document"
      :class="{
        'modal-dialog-centered': isCentered,
        'modal-lg': isSizeLarge,
        'modal-xl': isSizeExtraLarge
      }"
    >
      <div class="modal-content">
        <div class="mt-3 mr-3">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="onClose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-2"><slot /></div>
      </div>
    </div>
    <div class="modal-backdrop show" @click="onClose"></div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    isCentered: {
      type: Boolean,
      default: true
    },
    isSizeLarge: {
      type: Boolean,
      default: false
    },
    isSizeExtraLarge: {
      type: Boolean,
      default: false
    },
    enabled: {
      type: Boolean,
      default: true
    },
  },
  updated () {
    document.body.classList.toggle('modal-open-two', this.show)
  },
  mounted () {
    document.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.onClose()
      }
    })
  },
  methods: {
    onClose () {
      if (this.enabled) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-content {
  height: 90%;
}
</style>
